// Цвета VIP-уровней зависят от темы: серебро/платина/бриллиант были рассчитаны
// на чёрный фон и на кремовом становились нечитаемыми.
const LIGHT = {
  Diamond: "#1F6F85",
  Platinum: "#4F4F4F",
  Gold: "#A8782F",
  Silver: "#6F6F6F",
  Standard: "rgba(74,20,16,0.6)",
};

export const vipTextColor = (level, theme, fallback) =>
  (theme === "light" ? LIGHT[level] : null) || fallback;

// Фон значка уровня: на кремовом нужен светлый, а не полупрозрачный чёрный.
export const vipBadgeBg = (level, theme, fallback) =>
  theme === "light" ? "rgba(74,20,16,0.06)" : fallback;
